/* eslint-disable sort-keys */
export default {
	formId: "registrationForm",
	formField: {
		firstName: {
			name: "firstName",
			label: "First name *",
			requiredErrorMsg: "First name is required"
		},
		lastName: {
			name: "lastName",
			label: "Last name *",
			requiredErrorMsg: "Last name is required"
		},
		email: {
			name: "email",
			label: "Email *",
			requiredErrorMsg: "A valid email address is required",
			invalidErrorMsg: "Not a valid email address."
		},
		password: {
			name: "password",
			label: "Password *",
			requiredErrorMsg: "Please choose a secure password."
		},
		passwordConfirm: {
			name: "passwordConfirm",
			label: "Confirm Password *",
			requiredErrorMsg: "Please confirm your password.",
			invalidErrorMsg: "Passwords must match."
		},
		addressLine1: {
			name: "addressLine1",
			label: "Address Line 1",
			requiredErrorMsg: "Address Line 1 is required"
		},
		addressLine2: {
			name: "addressLine2",
			label: "Address Line 2",
			requiredErrorMsg: "Address Line 2 is required"
		},
		city: {
			name: "city",
			label: "City *",
			requiredErrorMsg: "City is required"
		},
		state: {
			name: "state",
			label: "State *",
			requiredErrorMsg: "State is required"
		},
		zip: {
			name: "zip",
			label: "Zip Code",
			requiredErrorMsg: "Zip Code is required"
		},
		phone: {
			name: "phone",
			label: "Cell Phone",
			requiredErrorMsg: "A valid cell phone is required."
		},
		type: {
			name: "type",
			label: "I am A *",
			requiredErrorMsg: "Please indicate your relationship."
		},
		interest: {
			name: "interest",
			label: "I'm interested in *",
			requiredErrorMsg: "Please indicate your interest."
		},
		yob: {
			name: "yob",
			label: "Year of Birth"
		},
		howFoundOut: {
			name: "howFoundOut",
			label: "How did you find us?"
		}
	}
};
